import raygun from './raygun/raygun.config';

export default {
  init: (): void => {
    raygun.init();
  },
};
